import React, { useEffect, useState } from "react";
import { Autocomplete, Box, IconButton, Modal, TextField, Typography } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import AddMasterInventory from "./AddMasterInventory";
import EditMasterInventory from "./EditMasterInventory";
import { toast } from "react-toastify";
import { useCreateInventoryMutation, useDeleteInventoryMutation, useGetAllMasterInventoryQuery, useSearchVendorQuery, useSuggestedInventoryNameQuery } from "../../../Services/inventory/Inventory";
import DeleteModal from "../DeleteModal";
import './styles.scss'
import useThemeColors from "../../vehicle/ThemeColors";
import { Loader } from "react-bootstrap-typeahead";

const MasterInventory = () => {

    const [tableLoader, setTableLoader] = useState(false);

    const [fetchInventoryData, setFetchInventoryData] = useState([])
    const [searchTerms, setSearchTerms] = useState({});
    const [getVendorName, setGetVendorName] = useState([]);

    const [errors, setErrors] = useState({
  vendor_name: false,
  invoice_number: false,
  invoice_date: false,
  // part_number:false,
  // description: false,
  // hsn: false,
  // gst:false,
  // quantity:false,
  // price: false
});


    const [loading, setLoading] = useState(false)
    const [inventoryCreateData, setInventoryCreateData] = useState({
      // merge: true,
        vendor_name: "",
        invoice_number: "",
        invoice_date: "",
      });

    const [storeData, setStoreData] = useState({});

    const {
        data: masterInventoryData,
        status,
        isLoading,
        refetch,
    } = useGetAllMasterInventoryQuery({});

    useEffect(() => {
        if (masterInventoryData) {
            setFetchInventoryData(masterInventoryData?.results)
        }

    }, [masterInventoryData])

    const { data: masterInventory } = useGetAllMasterInventoryQuery({});
    const {data: searchVendor} = useSearchVendorQuery(inventoryCreateData?.vendor_name, { skip: !inventoryCreateData?.vendor_name})

    console.log(searchVendor, "searchVendorrrr")

    useEffect(() => {
      if (searchVendor) {

        setGetVendorName(searchVendor)
      }

    }, [searchVendor])

    const [createInventoryTrigger, {isLoading: createInventoryLoading, status:createInventoryStatus}] = useCreateInventoryMutation()


    useEffect(() => {
      if (createInventoryStatus === "pending") {
        setLoading(true)

      }
      else {
        setLoading(false)
      }

    }, [createInventoryStatus])

    // useEffect(() => {
    //     if (bulkUploadData) {
    //         setMasterInventoryDataa(bulkUploadData?.results);
    //     }
    // }, [bulkUploadData]);

    const [triggerDelete] = useDeleteInventoryMutation();


    const {data: searchNameData, isLoading: searchedNameData, status: searchedNameStatus } = useSuggestedInventoryNameQuery(searchTerms, { skip: !searchTerms})

    // useEffect(() => {
    //     if (bulkUploadData) {
    //         setInventoryData(bulkUploadData?.results);
    //     }
    // }, [bulkUploadData]);
    console.log(searchNameData, "earchchhc")

    useEffect(() => {
        if (status === "pending") {
            setTableLoader(true);
        } else {
            setTableLoader(false);
        }
    }, [status]);

 

    const masterTableHeader = [
        { label: "S.No", key: "sno" },
        { label: "Part number", key: "part_number" },
        { label: "Description", key: "inventory_name" },
        // { label: "Description", key: "description" },
        { label: "HSN code", key: "hsn" },
        { label: "Quantity", key: "quantity" },
        { label: "Unit price", key: "price" },
        { label: "GST", key: "gst" },
        { label: "MRP", key: "total" },
    ];

    const [inventoryRows, setInventoryRows] = useState<any>([
        {
            inv_name: "",
          part_number: "",
          // description: "",
          hsn: "",
          quantity: "",
          price: "",
          gst: "",
          total: "",
        },
      ]);

      const handleRowChange = (index, field, value) => {
        console.log(field, "firldldl")
        const updatedRows = [...inventoryRows];
        updatedRows[index][field] =
          field === "quantity" || field === "price" || field === "gst"
            ? Number(value)
            : value;
      
        // Recalculate total if quantity, price, or gst changed
        if (["quantity", "price", "gst"].includes(field)) {
          const quantity = updatedRows[index].quantity || 0;
          const price = updatedRows[index].price || 0;
          const gst = updatedRows[index].gst || 0;
      
          const subtotal = quantity * price;
          const gstAmount = (subtotal * gst) / 100;
          const total = subtotal + gstAmount;
      
          updatedRows[index].total = parseFloat(total.toFixed(2));
        }
      
        setInventoryRows(updatedRows);
        if (field === "inv_name" || field === "partId") {
            setSearchTerms((prev) => ({
              ...prev,
              [index]: value
            }));
          }
      };
      

      
      const saveHandler = async (e) => {
        e.preventDefault();

          const { vendor_name, invoice_number, invoice_date } = inventoryCreateData;

  const newErrors = {
    vendor_name: !vendor_name.trim(),
    invoice_number: !invoice_number.toString().trim(),
    invoice_date: !invoice_date.trim(),
  
  };

  setErrors(newErrors);

  const hasErrors = Object.values(newErrors).some(Boolean);

  if (hasErrors) {
    toast.warning("Please fill all required field")
    return; // stop form submission
  }
      
      const payload = {
  ...inventoryCreateData,
  items: inventoryRows.map(row => ({
    ...row,
    part_number: row.partId || "", // rename partId to part_number
    description: "test"
  })),
};

      
        const response = await createInventoryTrigger(payload)

        try {
            if (response?.data) {
                toast.success("Inventory added successfully")
                setInventoryRows([
                    {
                        part_number: "",
                        // description: "",
                        hsn: "",
                        quantity: "",
                        price: "",
                        gst: "",
                        total: "",
                      },
                ])

                setInventoryCreateData({
                  // merge: false,
                    vendor_name: "",
                    invoice_number: "",
                    invoice_date: "",
                })
                
            }
            else if ("data" in response?.error) {
                const errorMessage = response?.error?.data as { items: { hsn: string[] }[] }; // Define the shape of the error data
            
            
                const hsnErrors = errorMessage.items[0]?.hsn; // Getting the 'hsn' array from the first item
                
                if (Array.isArray(hsnErrors)) {
                    hsnErrors.forEach((err) => {
                        toast.error(err); // Show each hsn error message
                    });
                }
            }
            
            
        } catch (error) {
            
        }

      };

      // I want to send partId as part_number in API payload
      
      const handleAddRow = () => {
        setSearchTerms({})
        setInventoryRows([{
            inv_name: ""
          }
    ])

        setInventoryRows([
          ...inventoryRows,
          {
            part_number: "",
            // description: "",
            inv_name: "",
            hsn: "",
            quantity: "",
            price: "",
            gst: "",
            total: "",
          },
        ]);
      };
      

    const calculateTotal = (row: any) => {
        const quantity = parseFloat(row.quantity) || 0;
        const price = parseFloat(row.price) || 0;
        const gst = parseFloat(row.gst) || 0;
      
        const subtotal = quantity * price;
        const gstAmount = (subtotal * gst) / 100;
        const total = subtotal + gstAmount;
        
      
        return total.toFixed(2); // Always show 2 decimal places
      };


      const cancelInventory = () => {
        // closeModal()

        setInventoryRows([
            {
                part_number: "",
                // description: "",
                hsn: "",
                quantity: "",
                price: "",
                gst: "",
                total: "",
              },
        ])

        setInventoryCreateData({
          // merge: false,
            vendor_name: "",
            invoice_number: "",
            invoice_date: "",
        })
      }
      const {
          selectedColor,
          selectedButtonBackgoundColors,
          selectedButtonColors,
      } = useThemeColors();


  const deleteRowHandler = (index) => {
  const updatedRows = [...inventoryRows];
  updatedRows.splice(index, 1);
  setInventoryRows(updatedRows);
};



      
    return (
       <div className="vehicle-info-cont">

   <div
                className="vehicle-info-middle"
                style={{ boxShadow: `${selectedColor}80 1px 1px 10px 1px` }}
            >
  
           <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "20px"
                }}
            >
                <div style={{display: "flex", alignItems: "center", gap: "20px", justifyContent: "space-between", width: "100%"}}>
                <div style={{ display: "flex", flexDirection: "column" , width: "100%"}}>
                    <label style={{fontSize: "15px", fontWeight: "600"}} className="required">Vendor</label>
                  <Autocomplete
  freeSolo
  options={
    Array.isArray(getVendorName)
      ? getVendorName
          .map(item => item?.vendor_name)
          .filter(name => typeof name === 'string')
      : []
  }
  inputValue={inventoryCreateData.vendor_name || ""}
  onInputChange={(event, newInputValue) => {
    setInventoryCreateData({
      ...inventoryCreateData,
      vendor_name: newInputValue,
    });
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      placeholder="Vendor name..."
      className="form-control"
      style={{
        padding: "0px",
        borderRadius: "50px",
      }}
      error={!!errors.vendor_name}
      // helperText={errors.vendor_name ? "Vendor name is required" : ""}
    />
  )}
/>

                   
                </div>
                <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                    <label style={{fontSize: "15px", fontWeight: "600"}} className="required">Invoice Number</label>
                    <input
                    style={{borderRadius: "50px",     border: errors.invoice_number ? "1px solid red" : "1px solid #ced4da"
}}

                        className="form-control"
                        type="number"
                        value={inventoryCreateData.invoice_number}
                        placeholder="Invoice number..."

                        onChange={(e) => {

                          setInventoryCreateData({
                            ...inventoryCreateData,
                            invoice_number: e.target.value,
                          })
                          setErrors((prev) => ({
                            ...prev,
                            invoice_number: false
                          }))
                        }
                        }
                    />
                </div>
                <div style={{ display: "flex", flexDirection: "column" , width: "100%"}}>
                    <label style={{fontSize: "15px", fontWeight: "600"}}>Invoice Date</label>
                    <input
                      placeholder="DD/MM/YYYY"
                    style={{borderRadius: "50px",     border: errors.invoice_date ? "1px solid red" : "1px solid #ced4da"
}}
                        className="form-control"
                        value={inventoryCreateData.invoice_date}
                        // placeholder="Invoice Date..."
                        type="date"
  max={new Date().toISOString().split("T")[0]} // disables future dates

                        onChange={(e) => {

                          setInventoryCreateData({
                            ...inventoryCreateData,
                            invoice_date: e.target.value,
                          })
                          setErrors((prev) => ({
                            ...prev,
                            invoice_date: false
                          }))
                        }
                        }
                    />
                </div>
                </div>
       
            </div>

            </div>


{/* Header */}
<div 
     className="vehicle-info-bottom"
                style={{ boxShadow: `${selectedColor}80 1px 1px 10px 1px`, marginBottom: "20px" }}

>
            <div >
                <div >
                    <div
                        className="card p-4"
                        style={{ backgroundColor: "#F7D3C5" }}
                    >
                        <div className="row align-items-center" style={{padding: "0", width: "97%"}}>
                            {masterTableHeader?.map((card, index) => (
                                <div className="col" key={index}>
                                    <label htmlFor="" 
                                    // style={{paddingLeft: card?.label === "S.No" ? "10px" : ""}}
                                    style={{paddingLeft: "10px"}}
                                    >
                                        <strong className="required"
                                            style={{
                                                display: "flex",
                                                gap: "2px",

                                            }}
                                        >
{card?.label === "GST" ? (
  `${card.label} %`
) : card?.label === "Unit price" ? (
  <span style={{display: "flex", alignItems: "center"}}>
    <i className="bi bi-currency-rupee" style={{color: "black"}}></i> {card.label}
  </span>
) : (
  card.label
)}
                                        </strong>
                                    </label>
                                </div>
                            ))}
                         
                        </div>
                    </div>
                </div>
            </div>

            {/* Body */}
          {/* Body */}
<div>
  <div className="col" style={{ paddingRight: "0px" }}>

    {inventoryRows?.map((row, index) => {

          return (
            <div style={{display: "flex", alignItems: "center", padding: "5px", gap: "5px"}}>


      <div className=" mt-2 my-1 p-4" key={index} style={{background: "#F7D3C5", display: "flex", justifyContent: "space-between", alignItems: "center", width
        : "100%", gap: "10px"
      }}>
        <div>

        <div className="row align-items-start">
          <div className="col text-start">
            <input
            style={{
    padding: "8px"

            }}
              className="form-control"
              value={index + 1}
              disabled
            />
          </div>
        
           <div className="col text-start">

   <Autocomplete
  freeSolo
  options={
    Array.isArray(searchNameData)
      ? searchNameData
          .map(item => item?.partId)
          .filter(name => typeof name === 'string')
      : []
  }
  inputValue={row?.partId || ""}
  onInputChange={(event, newInputValue) => {
    handleRowChange(index, "partId", newInputValue);
  }}
  onChange={(event, newValue) => {
    const selectedItem = searchNameData?.find(item => item?.partId === newValue);

    if (selectedItem) {
      handleRowChange(index, "partId", selectedItem.partId); // update partId
      handleRowChange(index, "inv_name", selectedItem.inventoryName);
      handleRowChange(index, "hsn", selectedItem.hsnCode);
      handleRowChange(index, "gst", selectedItem.gst);
    }
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      placeholder="Part number"
      className="form-control"
      style={{ padding: "0px" }}
    />
  )}
/>

     



          </div>
          <div className="col text-start">
      <Autocomplete
  freeSolo
  options={
    Array.isArray(searchNameData)
      ? searchNameData
          .map(item => item?.inventoryName)
          .filter(name => typeof name === 'string')
      : []
  }
  inputValue={row.inv_name || ""}
  onInputChange={(event, newInputValue) => {
    handleRowChange(index, "inv_name", newInputValue);
   
  }}

  onChange={(event, newValue) => {
    const selectedItem = searchNameData?.find(item => item?.inventoryName === newValue);

    console.log(selectedItem, "selecteditem")

    if (selectedItem) {
      handleRowChange(index, "partId", selectedItem.partId);
      handleRowChange(index, "hsn", selectedItem.hsnCode);
      handleRowChange(index, "gst", selectedItem.gst);

    }
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      placeholder="Description"
      className="form-control"
      style={{ padding: "0px" }}
    />
  )}
/>

          </div>
       
     
          <div className="col text-start">
            <input
              className="form-control"
              placeholder="HSN"
              style={{
    // border: errors?.hsn ? "1px solid red" : "1px solid #ced4da"
    padding: "8px"

              }}

              value={row.hsn}
              disabled
              onChange={(e) =>
                handleRowChange(index, "hsn", e.target.value)
              }
            />
          </div>

      
          <div className="col text-start">
            <input
              className="form-control"
              placeholder="Quantity"
              type="number"
              style={{
    padding: "8px"
              }}
              value={row.quantity}
              onChange={(e) => {

                handleRowChange(index, "quantity", e.target.value)
           
              }
              }
            />
          </div>
          <div className="col text-start">
            <input
              className="form-control"
              placeholder="Unit Price"
              type="number"
              style={{
    padding: "8px"

    // border: errors?.price ? "1px solid red" : "1px solid #ced4da"

              }}
              value={row.price}
              onChange={(e) => {

                handleRowChange(index, "price", e.target.value)
                // setErrors((prev) => ({
                //   ...prev,
                //   price: false

                // }))
              }
              }
            />
          </div>
          <div className="col text-start">
            <input
              className="form-control"
              placeholder="GST"
              type="number"
              value={row.gst}
              style={{
    padding: "8px"

    // border: errors?.gst ? "1px solid red" : "1px solid #ced4da"
                
              }}
              disabled
              onChange={(e) => 
                handleRowChange(index, "gst", e.target.value)
              }
            />
          </div>
          <div className="col text-start">
            <input
              className="form-control"
              placeholder="Total"
              type="number"
              value={calculateTotal(row)}
              style={{
    padding: "8px"

              }}
    disabled
            />
          </div>
        </div>
        </div>


             <div><i className="bi bi-x-circle-fill" data-toggle="tooltip" data-placement="top" title="Delete" style={{fontSize: "15px"}}  onClick={() => {
      if (index > 0) deleteRowHandler(index);
    }} ></i></div>

      </div>
 
            </div>

          )

})}

  </div>
</div>

            <div 
            style={{padding: "10px 5px"}}
           
            >
                <span  onClick={handleAddRow} style={{
                                background:  `${selectedButtonBackgoundColors}`,
                                color: `${selectedButtonColors}`,
                                border: "none",
                                padding: "10px",
                                borderRadius: "20px",
                                fontSize: "15px",
                                  //  cursor: brandName.trim() ? "pointer" : "not-allowed",


                            }}>+ Add more parts</span>
            </div>

            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                    padding: "20px"
                }}
            >
                <button className="btn btn-secondary" onClick={cancelInventory} style={{  border: "none",
                                padding: "10px 20px",
                                borderRadius: "20px",}}>
                    Cancel
                </button>
                <button
                    // className="btn btn-primary"
                    onClick={saveHandler}
                     style={{
                                background:  `${selectedButtonBackgoundColors}`,
                                color: `${selectedButtonColors}`,
                                border: "none",
                                padding: "10px 20px",
                                borderRadius: "20px",
                                fontSize: "15px",
                                  //  cursor: brandName.trim() ? "pointer" : "not-allowed",


                            }}
                >
                
                    {loading ? <>Saving...<Loader /></> :"Save" }
                </button>
            </div>
            {/* </div> */}
            

    </div>
   

        </div>
    );
};

export default MasterInventory;
